// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__rYWt6","head":"ProcedureTableInfo_head__3Ewyr"};